var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_959_2571",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_959_2571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5H6C5.71667 15.5 5.47917 15.4042 5.2875 15.2125C5.09583 15.0208 5 14.7833 5 14.5C5 14.2167 5.09583 13.9792 5.2875 13.7875C5.47917 13.5958 5.71667 13.5 6 13.5H10C10.2833 13.5 10.5208 13.5958 10.7125 13.7875C10.9042 13.9792 11 14.2167 11 14.5V18.5C11 18.7833 10.9042 19.0208 10.7125 19.2125C10.5208 19.4042 10.2833 19.5 10 19.5C9.71667 19.5 9.47917 19.4042 9.2875 19.2125C9.09583 19.0208 9 18.7833 9 18.5V15.5ZM15 9.5H18C18.2833 9.5 18.5208 9.59583 18.7125 9.7875C18.9042 9.97917 19 10.2167 19 10.5C19 10.7833 18.9042 11.0208 18.7125 11.2125C18.5208 11.4042 18.2833 11.5 18 11.5H14C13.7167 11.5 13.4792 11.4042 13.2875 11.2125C13.0958 11.0208 13 10.7833 13 10.5V6.5C13 6.21667 13.0958 5.97917 13.2875 5.7875C13.4792 5.59583 13.7167 5.5 14 5.5C14.2833 5.5 14.5208 5.59583 14.7125 5.7875C14.9042 5.97917 15 6.21667 15 6.5V9.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.4272f533bc170c8725af6e79a41d76d8.svg";
export { ForwardRef as ReactComponent };